(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-benefits"] && !Shopify.designMode) return;
  try {
    
  function initIngBuBestellvorteile(block) {
    const container = block.querySelector(".ingbu-bestellvorteile__inner");
    const items = Array.from(block.querySelectorAll(".ingbu-bestellvorteile__icon-container"));
    const dotsWrapper = block.querySelector(".ingbu-bestellvorteile__dots");

    if (!container || !items.length || !dotsWrapper) return;
    if (dotsWrapper.dataset.ready === "true") return;

    dotsWrapper.dataset.ready = "true";

    items.forEach((item, i) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "ingbu-bestellvorteile__dot" + (i === 0 ? " is-active" : "");
      dot.addEventListener("click", () => {
        const left = item.offsetLeft - container.offsetLeft;
        container.scrollTo({ left, behavior: "smooth" });
      });
      dotsWrapper.appendChild(dot);
    });

    const dots = Array.from(block.querySelectorAll(".ingbu-bestellvorteile__dot"));

    function setActive(idx) {
      dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
    }

    if ("IntersectionObserver" in window) {
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              const index = items.indexOf(e.target);
              if (index !== -1) setActive(index);
            }
          });
        },
        { root: container, threshold: 0.6 }
      );

      items.forEach((item) => obs.observe(item));
    }
  }

  function initAllIngBuBestellvorteile() {
    document.querySelectorAll("[data-ingbu-bestellvorteile]").forEach(initIngBuBestellvorteile);
  }

  // Initial Load
  document.addEventListener("DOMContentLoaded", initAllIngBuBestellvorteile);

  // Shopify Editor Reload
  document.addEventListener("shopify:section:load", initAllIngBuBestellvorteile);

  } catch(e) { console.error(e); }
})();
})();
